import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "agency", "listing", "managerFee" ]

  connect() {
    if (this.hasAgencyTarget && this.hasListingTarget && this.agencyTarget.value === "") {
      this.listingTarget.disabled = true
    }
  }

  agencyChanged() {
    const populateUrl = this.element.dataset.bookingFormPopulateUrl
    if (!populateUrl || !this.hasAgencyTarget) return

    const agency = encodeURIComponent(this.agencyTarget.value)
    fetch(`${populateUrl}?booking[listing_agency]=${agency}`, {
      headers: { Accept: "application/json" }
    })
      .then((response) => response.ok ? response.json() : Promise.reject(response))
      .then((listings) => this.populateListings(listings))
      .catch(() => this.populateListings([]))
  }

  populateListings(listings) {
    if (!this.hasListingTarget) return

    const select = this.listingTarget
    select.replaceChildren()

    const blank = document.createElement("option")
    blank.text = ""
    blank.value = ""
    blank.disabled = true
    blank.selected = true
    select.appendChild(blank)

    listings.forEach(([name, id]) => {
      const option = document.createElement("option")
      option.text = name
      option.value = id
      select.appendChild(option)
    })

    select.disabled = listings.length === 0
  }

  collapseListing() {
    if (this.hasListingTarget && this.listingTarget.size !== 0) {
      this.listingTarget.size = 1
    }
  }

  calculateFee() {
    if (!this.hasManagerFeeTarget) return

    const listing = document.getElementById("booking_listing_id")
    const startDate = document.getElementById("booking_start_date")
    const endDate = document.getElementById("booking_end_date")
    if (!listing || !listing.value || !startDate || !endDate) return

    const refund = document.getElementById("booking_refund")
    const totalPrice = document.getElementById("booking_total_price")
    const cleaningCost = document.getElementById("booking_cleaning_cost")

    const days = Math.ceil((new Date(endDate.value) - new Date(startDate.value)) / (1000 * 3600 * 24))
    const params = new URLSearchParams({
      total_price: totalPrice ? totalPrice.value : "",
      booked_days: days,
      refund: refund ? refund.value : "",
      cleaning_cost: cleaningCost ? cleaningCost.value : ""
    })

    fetch(`/listings/${listing.value}/calculate_manager_fee/?${params}`, {
      headers: { Accept: "application/json" }
    })
      .then((response) => response.ok ? response.json() : Promise.reject(response))
      .then((result) => { this.managerFeeTarget.value = result })
      .catch(() => {})
  }
}
